module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "ui container main-content"
  }, [(_vm.checkClientWidth) ? _c('div', {
    staticClass: "ui two column grid",
    attrs: {
      "id": "mw-topheader"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._m(0), _vm._v(" "), (_vm.user.role > 0) ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "text-align": "right",
      "width": "33vw",
      "float": "right",
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "ui right floated "
  }, [_c('div', {
    staticClass: "client-name"
  }, [_c('h5', [_vm._v("Sveiki,"), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.user.name_surname))])])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: " ui floated  basic buttons",
    staticStyle: {
      "margin": "0 auto",
      "width": "100%"
    }
  }, [_c('button', {
    staticClass: "ui vertical animated button",
    class: {
      loading: _vm.userStoreStatus.loading
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'topup'
        })
      }
    }
  }, [_c('div', {
    staticClass: "ui hidden content",
    staticStyle: {
      "color": "#362b15!important"
    }
  }, [_vm._v("Atlikums")]), _vm._v(" "), _c('div', {
    staticClass: "ui visible content",
    staticStyle: {
      "color": "#362b15!important"
    }
  }, [_c('i', {
    staticClass: "money icon"
  }), _vm._v(_vm._s(_vm.user.balance) + " €\n            ")])]), _vm._v(" "), (_vm.user.enable_bonus) ? _c('button', {
    staticClass: "ui  vertical animated button",
    class: {
      loading: _vm.userStoreStatus.loading
    },
    attrs: {
      "id": "bonus"
    },
    on: {
      "mouseover": _vm.enablePopups
    }
  }, [_c('div', {
    staticClass: "hidden content",
    staticStyle: {
      "color": "#21ba45!important"
    }
  }, [_vm._v("Bonuss")]), _vm._v(" "), _c('div', {
    staticClass: "visible content",
    staticStyle: {
      "color": "#21ba45!important"
    }
  }, [_c('i', {
    staticClass: "gift icon"
  }), _vm._v(_vm._s(_vm.user.bonus) + " €\n                ")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "ui vertical animated button",
    class: {
      loading: _vm.cartStoreStatus.loading
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cart'
        })
      }
    }
  }, [_c('div', {
    staticClass: " hidden content",
    staticStyle: {
      "color": "#362b15!important"
    }
  }, [_vm._v("Pirkumu grozs")]), _vm._v(" "), _c('div', {
    staticClass: "visible content",
    staticStyle: {
      "color": "#362b15!important"
    }
  }, [_c('i', {
    staticClass: "shop icon "
  }), _vm._v(" "), (_vm.itemsInCart > 0) ? _c('span', [_vm._v(_vm._s(_vm.itemsInCart) + " gab.")]) : _c('span', [_vm._v("tukšs")])])])])])]) : _c('div', {
    staticClass: "ui right floated list"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "text-align": "right",
      "width": "33vw",
      "float": "right",
      "padding-top": "20px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "tiny ui right buttons"
  }, [_c('button', {
    staticClass: "ui basic vertical animated button custom_brown_bevel",
    class: {
      loading: _vm.cartStoreStatus.loading
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cart'
        })
      }
    }
  }, [_c('div', {
    staticClass: " hidden content "
  }, [_vm._v("Pirkumu grozs")]), _vm._v(" "), _c('div', {
    staticClass: "visible content "
  }, [_c('i', {
    staticClass: "shop icon "
  }), _vm._v(" "), (_vm.itemsInCart > 0) ? _c('span', [_vm._v(_vm._s(_vm.itemsInCart) + " gab.")]) : _c('span', [_vm._v("tukšs")])])])])]), _vm._v(" "), _vm._m(3)])])])]) : _c('div', {
    staticClass: "ui two column grid",
    attrs: {
      "id": "mw-topheader"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [(_vm.user.role > 0) ? _c('div', {
    staticClass: "ui right floated list"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('h5', [_vm._v("Sveiki, "), _c('b', [_vm._v(_vm._s(_vm.user.name_surname))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: " ui right floated  basic buttons"
  }, [_c('button', {
    staticClass: "ui vertical animated button",
    class: {
      loading: _vm.userStoreStatus.loading
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'topup'
        })
      }
    }
  }, [_c('div', {
    staticClass: "ui hidden content",
    staticStyle: {
      "color": "#362b15!important"
    }
  }, [_vm._v("Atlikums")]), _vm._v(" "), _c('div', {
    staticClass: "ui visible content",
    staticStyle: {
      "color": "#362b15!important"
    }
  }, [_c('i', {
    staticClass: "money icon"
  }), _vm._v(_vm._s(_vm.user.balance) + " €\n            ")])]), _vm._v(" "), (_vm.user.enable_bonus) ? _c('button', {
    staticClass: "ui vertical animated button",
    class: {
      loading: _vm.userStoreStatus.loading
    },
    attrs: {
      "id": "bonus"
    },
    on: {
      "mouseover": _vm.enablePopups
    }
  }, [_c('div', {
    staticClass: "hidden content",
    staticStyle: {
      "color": "#21ba45!important"
    }
  }, [_vm._v("Bonuss")]), _vm._v(" "), _c('div', {
    staticClass: "visible content",
    staticStyle: {
      "color": "#21ba45!important"
    }
  }, [_c('i', {
    staticClass: "gift icon"
  }), _vm._v(_vm._s(_vm.user.bonus) + " €\n                ")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "ui vertical animated button",
    class: {
      loading: _vm.cartStoreStatus.loading
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cart'
        })
      }
    }
  }, [_c('div', {
    staticClass: " hidden content",
    staticStyle: {
      "color": "#362b15!important"
    }
  }, [_vm._v("Pirkumu grozs")]), _vm._v(" "), _c('div', {
    staticClass: "visible content",
    staticStyle: {
      "color": "#362b15!important"
    }
  }, [_c('i', {
    staticClass: "shop icon "
  }), _vm._v(" "), (_vm.itemsInCart > 0) ? _c('span', [_vm._v(_vm._s(_vm.itemsInCart) + " gab.")]) : _c('span', [_vm._v("tukšs")])])])]), _vm._v(" "), _vm._m(5)])]) : _c('div', {
    staticClass: "ui right floated list",
    staticStyle: {
      "margin-top": "55px",
      "text-align": "right"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "tiny ui right floated  buttons"
  }, [_c('button', {
    staticClass: "ui basic vertical animated button custom_brown_bevel",
    class: {
      loading: _vm.cartStoreStatus.loading
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cart'
        })
      }
    }
  }, [_c('div', {
    staticClass: " hidden content "
  }, [_vm._v("Pirkumu grozs")]), _vm._v(" "), _c('div', {
    staticClass: "visible content "
  }, [_c('i', {
    staticClass: "shop icon "
  }), _vm._v(" "), (_vm.itemsInCart > 0) ? _c('span', [_vm._v(_vm._s(_vm.itemsInCart) + " gab.")]) : _c('span', [_vm._v("tukšs")])])])]), _vm._v(" "), _vm._m(7)])])])]), _vm._v(" "), _c('notifications'), _vm._v(" "), _c('top-menu'), _vm._v(" "), _c('transition', [_c('keep-alive', [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)], 1)], 1), _vm._v(" "), _c('footer-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://bioveikals.com"
    }
  }, [_c('img', {
    staticClass: "logo-mobile",
    attrs: {
      "src": require("./assets/bv_logo_small.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ui right big",
    staticStyle: {
      "font-size": "16px",
      "color": "#362b15!important"
    },
    attrs: {
      "id": "mw-phone",
      "href": "tel:0037120010800"
    }
  }, [_c('i', {
    staticClass: "call icon"
  }), _vm._v("200 108 00\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('h5', [_vm._v("Sveiki, "), _c('b', [_vm._v("Viesi")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('a', {
    staticClass: " ui right big",
    staticStyle: {
      "font-size": "16px",
      "color": "#362b15!important"
    },
    attrs: {
      "id": "mw-phone",
      "href": "tel:0037120010800"
    }
  }, [_c('i', {
    staticClass: "call icon"
  }), _vm._v("200 108 00\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('a', {
    attrs: {
      "href": "https://bioveikals.com"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./assets/bv_logo_small.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ui right floated big vertical button",
    attrs: {
      "id": "mw-phone",
      "href": "tel:0037120010800"
    }
  }, [_c('i', {
    staticClass: "call icon"
  }), _vm._v("200 108 00\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('h5', [_vm._v("Sveiki, "), _c('b', [_vm._v("Viesi")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: " ui right floated big vertical button",
    attrs: {
      "id": "mw-phone",
      "href": "tel:0037120010800"
    }
  }, [_c('i', {
    staticClass: "call icon"
  }), _vm._v("200 108 00\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e1bc452!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 324
// module chunks = 1